import { useEffect } from 'react';
import {Box} from '@mui/material';
import {t} from 'i18next';
import {useDispatch} from 'react-redux';
import {setDialogReportName} from '../../../redux/slices/reportsDialogSlice';
import HighLevelProductionReportDetails from './HighLevelProductionReportDetails';
import HighLevelProductionReportHeader from './HighLevelProductionReportHeaders';

const HighLevelProductionReportPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setDialogReportName(t('reports.projectOverview.tabs.tabProductionMetrics'))
    );
  }, []);

  return (
    <>
      <Box>
        <HighLevelProductionReportHeader />
        <HighLevelProductionReportDetails />
      </Box>
    </>
  );
};

export default HighLevelProductionReportPage;
